import Text from '@amzn/meridian/text';
import Textarea from '@amzn/meridian/textarea';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import ErrorMessage from './ErrorMessage';

interface TextareaProps extends React.ComponentProps<typeof Textarea> {
  maxLength?: number;
  errorText?: string;
  'data-*'?: string;
}

const Component: React.FC<TextareaProps> = ({
  name,
  value,
  onChange,
  label,
  placeholder,
  disabled,
  maxLength,
  errorText,
  ...props
}: TextareaProps): React.ReactElement => {
  const intl = useIntl();
  const [text, setText] = useState(value || '');
  const [charactersRemaining, setCharactersRemaining] = useState(
    maxLength && text !== undefined ? maxLength - text.toString().length : 0
  );

  const handleChange = (a: string): void => {
    setText(a);
    if (maxLength) setCharactersRemaining(maxLength - a.toString().length);
    if (onChange) onChange({ target: { name, value: a } });
  };

  return (
    <div>
      <Textarea
        name={name}
        value={text}
        onChange={handleChange}
        label={label}
        placeholder={placeholder}
        disabled={disabled}
        error={!!errorText || charactersRemaining < 0}
        width='100%'
        rows={3}
        resize='auto'
        errorMessage={charactersRemaining >= 0 && errorText}
        {...props}
      />
      {maxLength ? (
        <Text
          type='b200'
          alignment='right'
          color={charactersRemaining >= 0 ? 'secondary' : 'error'}
        >
          {charactersRemaining >= 0
            ? intl.formatMessage(
                {
                  id: 'cs_perfportal_textarea_characters_remaining',
                  defaultMessage: `{0} characters remaining`,
                },
                { 0: charactersRemaining }
              )
            : intl.formatMessage(
                {
                  id: 'cs_perfportal_textarea_character_limit_exceeded',
                  defaultMessage: `More than {0} characters`,
                },
                { 0: maxLength }
              )}
        </Text>
      ) : null}
    </div>
  );
};

export default Component;
